import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { settingsAPI } from '../lib/api';
import { Bell, Info } from 'lucide-react';
import { toast } from 'sonner';

export function SettingsPage() {
  const [testing, setTesting] = useState(false);

  const handleTestTelegram = async () => {
    setTesting(true);
    try {
      const response = await settingsAPI.testTelegram();
      if (response.data.success) {
        toast.success('Notifikasi Telegram berhasil dikirim!');
      } else {
        toast.error(response.data.message || 'Gagal mengirim notifikasi');
      }
    } catch (error) {
      toast.error('Gagal mengirim notifikasi Telegram');
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Pengaturan</h2>
        <p className="text-muted-foreground mt-1 text-sm sm:text-base">
          Konfigurasi sistem dan notifikasi
        </p>
      </div>

      <div className="grid gap-6 grid-cols-1 lg:grid-cols-2">
        {/* Telegram Notifications */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
              <Bell className="h-5 w-5 flex-shrink-0" />
              Notifikasi Telegram
            </CardTitle>
            <CardDescription className="text-xs sm:text-sm">
              Uji pengiriman notifikasi ke Telegram
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button 
              onClick={handleTestTelegram} 
              disabled={testing}
              className="w-full sm:w-auto"
            >
              <Bell className="h-4 w-4 mr-2" />
              {testing ? 'Mengirim...' : 'Uji Notifikasi Telegram'}
            </Button>
          </CardContent>
        </Card>

        {/* System Information */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
              <Info className="h-5 w-5 flex-shrink-0" />
              Informasi Sistem
            </CardTitle>
            <CardDescription className="text-xs sm:text-sm">
              Detail aplikasi dan organisasi
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3 text-sm sm:text-base">
              <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-4 p-3 bg-muted/50 rounded">
                <span className="font-medium">Aplikasi:</span>
                <span className="text-muted-foreground">SSL Monitoring Dashboard</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-4 p-3 bg-muted/50 rounded">
                <span className="font-medium">Versi:</span>
                <span className="text-muted-foreground">1.0.0</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-4 p-3 bg-muted/50 rounded">
                <span className="font-medium">Organisasi:</span>
                <span className="text-muted-foreground text-right sm:text-left">
                  Universitas Muslim Indonesia
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}